export default __webpack_public_path__ + "src/images/reports/report-details-shape.png";